import { Outlet } from 'react-router-dom';

import { SidebarInset, SidebarProvider } from '@/components/cargofl-ui';
import { AppSidebar } from '@/components/shell/app-sidebar';
import { PageErrorBoundary } from '@/components/shell/page-error-boundary';
import { TopBar } from '@/components/shell/top-bar';
import type { Session } from '@/lib/session';

/**
 * Authenticated shell: rail + top bar around the routed page.
 *
 * Route protection lives in <RequireAuth> (App.tsx), not here, so this can assume
 * a signed-in session.
 */
export function AppShell({ session }: { session: Session }) {
  return (
    <SidebarProvider>
      <AppSidebar session={session} />
      <SidebarInset>
        <TopBar session={session} />
        {/* min-w-0 so a wide table scrolls inside its own container instead of
            inflating this flex child and pushing the page sideways. */}
        <div className="min-w-0 flex-1">
          {/* Around the outlet, not the shell: a page that throws must not take the
              sidebar with it, or there is no way out but a reload. */}
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
